import { Image, Text as RNText, View } from 'react-native';

import { cn } from './cn';

export interface BrandMarkProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const GLYPH: Record<NonNullable<BrandMarkProps['size']>, number> = {
  sm: 20,
  md: 24,
  lg: 32,
};

const WORD: Record<NonNullable<BrandMarkProps['size']>, string> = {
  sm: 'text-[10px]',
  md: 'text-xs',
  lg: 'text-sm',
};

/** The Remove Before Flight tag mark + REMOVE BEFORE FLIGHT wordmark. */
export function BrandMark({ size = 'md', className }: BrandMarkProps) {
  return (
    <View className={cn('flex-row items-center gap-2 sm:gap-3', className)}>
      <Image
        source={require('../../../assets/images/brand-mark.png')}
        resizeMode="cover"
        style={{
          width: GLYPH[size],
          height: GLYPH[size],
          borderRadius: Math.round(GLYPH[size] * 0.25),
        }}
      />
      <RNText
        className={cn(
          'shrink font-accent uppercase tracking-[0.1em] text-foreground',
          WORD[size],
        )}
      >
        Remove Before Flight
      </RNText>
    </View>
  );
}
